/* unplugin-vue-components disabled */import { render } from "./CaseCard.vue?vue&type=template&id=08be9494&scoped=true"
import script from "./CaseCard.vue?vue&type=script&lang=js"
export * from "./CaseCard.vue?vue&type=script&lang=js"

import "./CaseCard.vue?vue&type=style&index=0&id=08be9494&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-案例中心-哈工程-前台页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08be9494"]])

export default __exports__